import styled from "styled-components";

export const Main = styled.main`
    overflow: hidden;
    color: #2770d8;
`;
